export enum MdrFeatureFlags {
    EnableClinicalEvaluationsAgent = 'enable-clinical-evaluations-agent'
}
